import { jbColors } from 'theme/jbColors';

const MuiSlider = {
  styleOverrides: {
    rail: {
      height: 8,
      color: jbColors.support.greenSmoke[20],
    },
    track: {
      height: 8,
      color: jbColors.core.reflexBlue[60],
    },
    thumb: {
      height: 28,
      width: 28,
      top: 8,
      backgroundColor: 'white',
      border: '2px solid #A8B0DE',
      boxShadow:
        '0px 6px 10px rgba(51, 51, 51, 0.1), 0px 1px 18px rgba(51, 51, 51, 0.1), 0px 3px 5px -1px rgba(51, 51, 51, 0.05)',
    },
    mark: {
      display: 'none',
    },
    markLabel: {
      display: 'none',
    },
  },
};

export default MuiSlider;
